module.exports = {
  title: 'No data',
};
